module.exports = __webpack_public_path__ + "static/coming_banner-2df9a7ed4230c30d9593927479c04a5e.png";